/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Chat_Tool_Detail_ChunksInputs */

const es_chat_tool_detail_chunks = /** @type {(inputs: Chat_Tool_Detail_ChunksInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} fragmentos`)
};

const en_chat_tool_detail_chunks = /** @type {(inputs: Chat_Tool_Detail_ChunksInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} chunks`)
};

/**
* | output |
* | --- |
* | "{count} chunks" |
*
* @param {Chat_Tool_Detail_ChunksInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const chat_tool_detail_chunks = /** @type {((inputs: Chat_Tool_Detail_ChunksInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Tool_Detail_ChunksInputs, { locale?: "es" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_chat_tool_detail_chunks(inputs)
	return en_chat_tool_detail_chunks(inputs)
});
export { chat_tool_detail_chunks as "chat.tool_detail.chunks" }